import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getApiData as getRoleDataApi } from 'services/RoleService'
import { getApiPermissionData } from 'services/PermissionService'
import { actionType, moduleName, title } from 'components/helper'
import { moduleList } from 'utils/options'
import { ApiQuestionnairesLists, ApiQuestionsLists } from 'services/RiskService'



export const getRoleData = createAsyncThunk('listdata/getRoleData', async () => {
    const response = await getRoleDataApi()
    return response.data.results?.map(item => {
        item.label = item.name
        item.value = item.id
        return item
    })
})


export const getPermissionData = createAsyncThunk('listdata/getPermissionData', async () => {
    const response = await getApiPermissionData()
    const moduleData = response.data.results
        .filter(item => !item.name.includes('delete'))
        .filter(item => {
            let name = item.name.split(' ')
            name.splice(0, 2)
            name = name.join(' ')
            return moduleList.find(value => value.key === name)
        })
        .map(item => {
            let nameArr = item.name.split(' ')
            nameArr.splice(0, 2)
            nameArr = nameArr.join(' ')
            item.module = moduleName(nameArr)
            item.action = actionType(item.name)
            item.title = title(item.name)
            return item
        })
    return Object.groupBy(moduleData, ({ module }) => module)
})
export const getQuestionnairesData = createAsyncThunk('listdata/getQuestionnairesData', async () => {
    const response = await ApiQuestionnairesLists()
    return response.data.results?.map(item => {
        item.label = item.code
        item.value = item.id
        return item
    })
})
export const getQuestionsData = createAsyncThunk('listdata/getQuestionsData', async () => {
    const response = await ApiQuestionsLists()
    return response.data.results?.map(item => {
        item.label = item.code
        item.value = item.id
        return item
    })
})
const dataSlice = createSlice({
    name: 'listdata',
    initialState: {
        roleData: [],
        permissionList: [],
        questionnairesData: [],
        questionsData: [],
        loading: false,
        error: null,
    },
    reducers: {

        setRoleData: (state, { payload }) => {
            state.roleData = payload
        },

    },
    extraReducers: builder => {
        builder
            //role data
            .addCase(getRoleData.pending, state => {
                state.loading = true
            })
            .addCase(getRoleData.fulfilled, (state, action) => {
                state.loading = false
                state.roleData = action.payload
            })
            .addCase(getRoleData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            //permission data
            .addCase(getPermissionData.pending, state => {
                state.loading = true
            })
            .addCase(getPermissionData.fulfilled, (state, action) => {
                state.loading = false
                state.permissionList = action.payload
            })
            .addCase(getPermissionData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })

            // Questionnaires 

             .addCase(getQuestionnairesData.pending, state => {
                state.loading = true
            })
            .addCase(getQuestionnairesData.fulfilled, (state, action) => {
                state.loading = false
                state.questionnairesData = action.payload
            })
            .addCase(getQuestionnairesData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
            // Questions 
            .addCase(getQuestionsData.pending, state => {
                state.loading = true
            })
            .addCase(getQuestionsData.fulfilled, (state, action) => {
                state.loading = false
                state.questionsData = action.payload
            })
            .addCase(getQuestionsData.rejected, (state, action) => {
                state.loading = false
                state.error = action.error.message
            })
    },
})

export const {  setRoleData } = dataSlice.actions

export default dataSlice.reducer
